import {createApp} from 'vue';
import App from '@/apps/profile/App.vue';
import router from '@/apps/profile/router'
import store from '@/apps/profile/store';
import i18n from '@/i18n';
import {setupGlobalComponents} from '@/global-components';

(async () => {
    await store.dispatch('load_user', window.appConfig.user);
    await store.dispatch('load_client', window.appConfig.client);
    await store.dispatch('initShopCart', window.appConfig.shopCart);

    const app = createApp(App);
    setupGlobalComponents(app, router);
    app.use(store);
    app.use(router);
    app.use(i18n);
    app.mount('#app');
})();
